import React from "react";
import { Router } from "@reach/router";

import Dashboard from "./components/Dashboard";

const App = () => (
  <Router>
    <Dashboard path="/" nation="us" />
    <Dashboard path="/us" nation="us" />
    <Dashboard path="/canada" nation="ca" />
  </Router>
);

export default App;